"use client";

import React from "react";
import { Input } from "../ui/input";
import { SectionCard } from "./SectionCard";
import { FieldRow } from "./FieldRow";
import { FileDropzone } from "./FileDropzone";
import type { FileBuckets, UploadStateMap } from "./types";
import { submissionContent, uploadAccepts } from "./content";

const mandatoryMessage = "Your answer is required.";

export function SupplierSection({
  fileBuckets,
  setBucket,
  uploadState,
  onRemoveFile,
  disablePicker,
  invalidBuckets = [],
  invalidFields = [],
  onLimitExceeded,
}: {
  fileBuckets: FileBuckets;
  setBucket: (key: string, files: File[]) => void;
  uploadState: UploadStateMap;
  onRemoveFile: (key: string, idx: number) => void;
  disablePicker?: boolean;
  invalidBuckets?: string[];
  invalidFields?: string[];
  onLimitExceeded?: (title: string, message: string) => void;
}) {
  const c = submissionContent.supplier;
  const isInvalid = (name: string) => invalidFields.includes(name);

  return (
    <SectionCard title={c.title}>
      <FieldRow label={c.companyName} required error={isInvalid("supplier_company_name") ? mandatoryMessage : undefined}>
        <Input
          name="supplier_company_name"
          className="h-11 rounded-xl"
          required
          data-invalid={isInvalid("supplier_company_name") ? "true" : "false"}
        />
      </FieldRow>

      <FileDropzone
        name="supplier_company_profile"
        label={c.profile}
        helper={c.profileHint || "Please upload your company profile and product list."}
        required
        accept={uploadAccepts.supplierProfile}
        files={fileBuckets.supplier_company_profile || []}
        setFiles={(n) => setBucket("supplier_company_profile", n)}
        uploadEntries={uploadState.supplier_company_profile || []}
        onRemoveFile={(idx) => onRemoveFile("supplier_company_profile", idx)}
        disablePicker={disablePicker}
        isInvalid={invalidBuckets.includes("supplier_company_profile")}
        maxFiles={10}
        maxTotalBytes={30 * 1024 * 1024}
        onLimitExceeded={onLimitExceeded}
      />

      <FieldRow label={c.contactName} required error={isInvalid("supplier_contact_name") ? mandatoryMessage : undefined}>
        <Input
          name="supplier_contact_name"
          className="h-11 rounded-xl"
          required
          data-invalid={isInvalid("supplier_contact_name") ? "true" : "false"}
        />
      </FieldRow>

      <FieldRow label={c.email} required error={isInvalid("supplier_contact_email") ? mandatoryMessage : undefined}>
        <Input
          name="supplier_contact_email"
          type="email"
          className="h-11 rounded-xl"
          required
          data-invalid={isInvalid("supplier_contact_email") ? "true" : "false"}
        />
      </FieldRow>

      <FieldRow
        label={c.mobile}
        required
        error={isInvalid("supplier_contact_mobile_wechat") ? mandatoryMessage : undefined}
      >
        <Input
          name="supplier_contact_mobile_wechat"
          className="h-11 rounded-xl"
          required
          data-invalid={isInvalid("supplier_contact_mobile_wechat") ? "true" : "false"}
        />
      </FieldRow>
    </SectionCard>
  );
}
